import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import './task-grid-loading.css';

export interface TaskGridLoadingPanelProps {
  showSkeleton?: boolean;
}

const TaskGridLoadingPanel = ({ showSkeleton = true }: TaskGridLoadingPanelProps) => (
  <div className="task-grid-loading" role="status" aria-live="polite" aria-busy="true">
    <div className="task-grid-loading__notice">
      <FaSpinner className="task-grid-loading__spinner" size={28} aria-hidden />
      <p className="task-grid-loading__title">Carregando tarefas...</p>
      <p className="task-grid-loading__hint">
        Com muitos registros, a listagem pode levar alguns instantes. Aguarde sem recarregar a página.
      </p>
    </div>
    {showSkeleton ? (
      <div className="task-grid-loading__skeleton grid-usuario__loading">
        <div className="grid-usuario__skeleton-row" />
        <div className="grid-usuario__skeleton-row" />
        <div className="grid-usuario__skeleton-row" />
        <div className="grid-usuario__skeleton-row" />
        <div className="grid-usuario__skeleton-row" />
      </div>
    ) : null}
  </div>
);

export default TaskGridLoadingPanel;
